module.exports = {
  region: 'eu-west-2',
  userPool: process.env.NX_REACT_APP_AWS_COGNITO_USER_POOL,
  identityPool: process.env.NX_REACT_APP_AWS_IDENTITY_POOL,
  clientId: process.env.NX_REACT_APP_AWS_COGNITO_CLIENT_ID,
};
